import React, { useState } from "react";
import { Table, Row, Col, Button, Form } from "react-bootstrap";
import CustomDropdown from "utils/CustomDropdown";

const DashboardSubheader = (props) => {
  return (
    <>
      <div className="dashboard-subheader d-flex mx-md-0 mx-2 pt-3 pt-md-0 pb-md-5 pb-3">
        <p className="text-primary subheader-text pr-0 pr-md-3 pt-md-2 pt-0">Select view:</p>
        {props.tabLocation !== "ppc" ?

          <CustomDropdown seo={props.seo} search={props.search} display={props.display} video={props.video} social={props.social} tabLocation={props.tabLocation} section="Performance" dashboards={props.dashboards} selectedDashboard={props.selectedDashboard} setSelectedDashboard={props.setSelectedDashboard} />
          :
          <Form.Control
            className="primary mb-2"
            size="md"
            as="select"
            onChange={(e) => props.setSelectedDashboard(parseInt(e.target.value))}
            style={{ width: "256px", paddingLeft: "20px", marginLeft: "3px" }}
            value={props.selectedDashboard}
          >
            {props.dashboards.map((dashboard, index) => {
              return (
                <option key={index} value={dashboard.id}>{dashboard.name}</option>
              )
            })}
          </Form.Control>
        }
      </div>
    </>
  )
}

export default DashboardSubheader;

